<template>
  <div class="article-wrap">
    <div class="article-content">
      <div class="match-category">
        <p>{{ match.match_no }}</p>
        <span class="live_match" v-if="match.isLive"><strong>Live</strong></span>
        <span class="post-date" v-else><strong>{{matchScheduleTime(match)}}</strong></span>
      </div>
      <div class="venue">
        <h4>
          <span>{{ match.venue_name }}</span>
        </h4>
      </div>
      <div class="teams">
        <div class="team team-a">
          {{ match.team1_name }}
          <span class="score" v-if="getTeamScore(match, match.team1_id, true)" v-html="getTeamScore(match, match.team1_id)"></span>
        </div>
        <div class="team team-b">
          {{ match.team2_name }}
          <span class="score" v-if="getTeamScore(match, match.team2_id, true)" v-html="getTeamScore(match, match.team2_id)"></span>
        </div>
      </div>
      <div class="match-date" v-if="match.match_result">
        <strong>{{match.match_result}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["match"],
  methods: {
    getScoreMarkup(score) {
      let scr = score.split(" ");
      return `<span class="score-a">
          <span class="runs">${scr[0]}</span>
          <span class="over">${scr[1]}</span>
        </span>`
    },
    getTeamScore(match, teamId, boolFlag) {
      let team1score = "", splitter = " & ";
      if(teamId === match.innings1_battingteam) {
        team1score = this.getScoreMarkup(match.innings1_score);
      }
      if(teamId === match.innings2_battingteam) {
        team1score = (team1score ? `${team1score}${splitter}` : "") + this.getScoreMarkup(match.innings2_score);
      }
      if(teamId === match.innings3_battingteam) {
        team1score = (team1score ? `${team1score}${splitter}` : "") + this.getScoreMarkup(match.innings3_score);
      }
      if(teamId === match.innings4_battingteam) {
        team1score = (team1score ? `${team1score}${splitter}` : "") + this.getScoreMarkup(match.innings4_score);
      }

      if(boolFlag){
        return !!(team1score);
      } else {
        return team1score;
      }
    },
    matchScheduleTime(match) {
      let {custom_date, custom_time} = match;
      if(custom_date && custom_time) {
        return `${custom_date} | ${custom_time}`;
      } else {
        return "";
      }
    }
  }
};
</script>